module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "ded"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("For Windop. And in memory of my grandmother, who wanted to avoid the shame and died while I was completing the last pages of the manuscript.")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Any similarity between existing people and certain characters in this book is due solely to insight into human nature.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52225901","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ded.vue
// module id = 69
// module chunks = 0